import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../utilities/LogErrors'

import { Loading } from './../../../Common/Loading'
//import { Header } from './../../../Header/Header'
import { Header } from './../../../Header/V2/Header'
import { Section } from './../../Section'

import { GetCurrentCenter as BLGetCurrentCenter, GetNickname as BLGetNickname, ResetGroupToShow, GetZtudentDataToGames as BLGetZtudentDataToGames } from './../../../../utilities/BL/Navigation'
import { useTawk } from './../../../../Support/Chat/Chat'
import { OpenTawkChat } from './../../../../Support/Chat/Client'
import { DeleteInstructorProgressData } from './../../../../utilities/BL/Sessions'
import { GetCenterFreeLicensesStatus as BLGetCenterFreeLicensesStatus } from './../../../../utilities/BL/Instructor/Licenses'

import { CreditsText } from './../../../Common/Credits/CreditsText'
import { BodyWithSideMenu } from './../../BodyWithSideMenu'
import { WEBPAGES } from './../../../../utilities/EL/WebPages'
import { HELP_TYPE } from './../../../../utilities/EL/HelpType'
import { TYPE_PROPOSITION_VALUE } from './../../../../utilities/EL/TypePropositionValue'
import { ROLES } from './../../../../utilities/EL/Roles'
import { CreateSession as BLCreateSession, /* GetGameStatus as BLGetGameStatus, */ ToggleGameAccess as BLToggleGameAccess } from './../../../../utilities/BL/Games/Games'
import { Confirm } from './../../../Common/Modals/Confirm'


const Applicant = ({ theme, setTheme }) => {
    const navigate = useNavigate()
    // const { setForceVisible } = useTawk()

    // useEffect(() => {
    //     // Al montar el componente → pide mostrar chat
    //     setForceVisible(true)

    //     // Al desmontar → lo libera
    //     return () => {
    //         setForceVisible(false)
    //     }
    // }, [setForceVisible])
    
    const [isLoading, setIsLoading] = useState(true)
    const [theTheme] = useState(theme)

    const [currentCenter, setCurrentCenter] = useState(null)
    const [nickname, setNickname] = useState(null)
    //const [ztudentData, setZtudentData] = useState(null)

    // Tile "Licencias Ztudia": deshabilitado por defecto (fail-safe) hasta que se confirme
    // por GetCenterFreeLicensesStatus que el centro NO está en modalidad de licencias gratuitas.
    const [isLicensesTileEnabled, setIsLicensesTileEnabled] = useState(false)

    // ESTADOS PARA EL JUEGO
    const [isGameActive, setIsGameActive] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [pendingToggleState, setPendingToggleState] = useState(false)
    const [confirmData, setConfirmData] = useState(null)
    const GAME_IDENTIFIER = 'tiro-a-gol'

    const typePropositionValue = {
        ZTUDENT: 1,
        INSTRUCTOR: 2
    }

    const typeHelp = {
        ZTUDENT: {
            DASHBOARD: 1
        },
        INSTRUCTOR: {
            DASHBOARD: 2
        }
    }

    // Comentado: esta llamada consulta un servicio interno separado
    // (REACT_APP_INTERNAL_API_URL) que sigue apuntando a localhost y no está disponible
    // fuera de la máquina del desarrollador original, por lo que marca error y agrega
    // tiempo de espera en cada carga del dashboard (ver rama "comentar tiro a gol").
    // isGameActive queda en false (su valor por defecto), como si la dinámica estuviera
    // deshabilitada.
    // const LoadGameStatus = async (centerId) => {
    //     try {
    //         const response = await BLGetGameStatus(centerId, GAME_IDENTIFIER)
    //
    //         if (response.success) {
    //             setIsGameActive(response.data.isActive)
    //         }
    //     } catch (error) {
    //
    //     }
    // }

    const DeleteProgressDataInLocalStorageAndGoToNextView = async () => {
        try {
            setIsLoading(true)
            
            await DeleteInstructorProgressData()
            navigate('/instructor/progress')
        } catch (error) {
            await LogErrors('DeleteProgressDataInLocalStorageAndGoToNextView - Instructor', error)
        } finally {
            setIsLoading(false)
        }
    }

    const GetZtudentDataToGames = async (idGame) => {
        try {
            setIsLoading(true)
            
            // Obtener info del Ztudiante para las dinámicas digitales
            const responseZtudentDataToGames = await BLGetZtudentDataToGames(idGame)
            
            if (responseZtudentDataToGames.success) {
                const ztudentDataToGames = responseZtudentDataToGames?.data

                if (!ztudentDataToGames) {
                    return
                }
                //setZtudentData(ztudentDataToGames)
                const responseCreateSession = await BLCreateSession(ztudentDataToGames)
                
                if (responseCreateSession.success) {
                    const magicLink = responseCreateSession.data
                    
                    if (magicLink) {
                        // 3. Redireccionamos al usuario a la nueva plataforma
                        window.location.href = magicLink
                    }
                }
            }
        } catch (error) {
            await LogErrors('GetZtudentDataToGames - Instructor', error)
        } finally {
            setIsLoading(false)
        }
    }

    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')
            
            await ResetGroupToShow()
            
            const response = await BLGetCurrentCenter()
            
            if (response.success) {
                // let centerId = response?.data?.id

                // if (!centerId) {
                //     return
                // }

                // // Si el dato viene como cadena, convertirlo a entero
                // if (typeof centerId === "string") {
                //     centerId = parseInt(centerId)
                // }
                
                // response.data.id = centerId

                // setCurrentCenter(response.data)

                let centerId = parseInt(response?.data?.id)
                response.data.id = centerId
                setCurrentCenter(response.data)

                // Comentado junto con LoadGameStatus (ver rama "comentar tiro a gol").
                // await LoadGameStatus(centerId)
            }
 

            // Obtener info del alias del usuario para utilizar cierta info en la pantalla
            const responseNickname = await BLGetNickname()
            
            if (responseNickname.success) {
                const nickname = responseNickname?.data

                if (!nickname) {
                    return
                }

                setNickname(nickname)
            }

            // Estado del tile "Licencias Ztudia": se habilita solo si el centro NO está en
            // modalidad de licencias gratuitas (isFreeLicenses === false).
            const responseFreeLicenses = await BLGetCenterFreeLicensesStatus()

            if (responseFreeLicenses.success) {
                // Se aceptan ambas grafías por seguridad, ante el mismo desajuste de mayúsculas
                // visto en otros endpoints (documentación en PascalCase, respuesta en camelCase).
                const isFreeLicenses = responseFreeLicenses.data?.isFreeLicenses ?? responseFreeLicenses.data?.IsFreeLicenses
                setIsLicensesTileEnabled(isFreeLicenses === false)
            } else {
                await LogErrors('LoadPage - Instructor (GetCenterFreeLicensesStatus)', responseFreeLicenses)
            }
        } catch (error) {
            await LogErrors('LoadPage - Instructor', error)
        } finally {
            setIsLoading(false)
        }
    }

    // MANEJADORES DEL SWITCH
    const handleSwitchClick = (e) => {
        e.stopPropagation(); // Evita que el clic en el switch dispare el clic de la tarjeta completa
        const newState = !isGameActive;
        setPendingToggleState(newState);
        setShowConfirmModal(true);
    }

    // Esta función ahora retorna el objeto para que tu Confirm.js lo evalúe
    const confirmToggle = async () => {
        setIsLoading(true);

        const userData = JSON.parse(sessionStorage.getItem('userData'));
        
        const toggleData = {
            CenterId: currentCenter.id,
            GameIdentifier: GAME_IDENTIFIER,
            IsActive: pendingToggleState,
            InstructorId: userData?.user?.id || 0,
            InstructorName: `${userData?.user?.name} ${userData?.user?.lastName}`
        };
        
        const response = await BLToggleGameAccess(toggleData);
        
        setIsLoading(false);
        
        // Retornamos el resultado para que el componente Confirm sepa qué hacer
        if (response.success) {            
            setIsGameActive(pendingToggleState);
            //setIsGameActive(response.data.isActive);
            return { success: true };
        } else {
            return { success: false, message: response.message || "Ocurrió un error al actualizar el juego." };
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        LoadPage()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    ////useTawkChat(true) // Activamos el chat en esta página
    //useTawkVisibility(true) // Activamos el chat en esta página


    return (
        isLoading ? (
            <Loading />
        ) : (
            <BodyWithSideMenu page={WEBPAGES.INSTRUCTOR.DASHBOARD} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.INSTRUCTOR} idHelp={HELP_TYPE.INSTRUCTOR.DASHBOARD} role={ROLES.INSTRUCTOR} >
                {/* <Header theme={theTheme} propositionValue={typePropositionValue.INSTRUCTOR} idHelp={HELP_TYPE.INSTRUCTOR.DASHBOARD} /> */}
                <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.INSTRUCTOR} idHelp={HELP_TYPE.INSTRUCTOR.DASHBOARD} />

                <main className='container Dashboard--V2 Container-FullHeight Fonts--PlusJakartaSans'>
                    <p className='Dashboard--V2__Title'>Bienvenid@ <span className='Dashboard--V2__Text--Highlight'>{(nickname && nickname !== '') && ` ${nickname}`}</span></p>
                    {currentCenter?.name && (
                        <p className='Dashboard--V2__Text Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Centro: {currentCenter.name}</p>
                    )}
                    <p className='Dashboard--V2__SpaceUp'>Ingresa a la opción que desees</p>

                    {/* {(currentCenter.id === 2) && (
                        <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                            <p className='Dashboard--V2__Sections__Title'>Celebremos el día del estudiante</p>
                            <p className='Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Con la dinámica que les hemos preparado ¡Conócela aquí!</p>

                            <div className='Dashboard--V2__Sections__List'>
                                <div
                                    className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink'
                                    onClick={() => {
                                        GetZtudentDataToGames(1)
                                        
                                        // Solo los dejamos pasar si el juego está activo
                                        // if (isGameActive) {
                                        //     GetZtudentDataToGames(1)
                                        // } else {
                                        //     alert("Esta dinámica está inhabilitada por el momento.");
                                        // }
                                    }}
                                >
                                    {/* CONTENIDO DE LA TARJETA /}
                                    <div style={{ width: '100%' }}>
                                        <div className="d-flex justify-content-between align-items-start w-100">
                                            <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                                <i className='bi bi-controller Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                            </figure>
                                        </div>

                                        <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Tiro a gol (1 vs 1)</p>
                                        
                                        <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                            <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Compite en esta divertida dinámica contra un compañer@ o amig@ para ver quién logra anotar primero un gol</li>
                                            {/* <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>2 estudiantes compiten en esta divertida dinámica para ver quién anota primero un gol</li> /}
                                        </ul>
                                    </div>

                                    <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' disabled={!isGameActive}>
                                        <i className='bi bi-arrow-right'></i>
                                    </button>
                                </div>
                            </div>

                            <p className='Dashboard--V2__Text--Small Dashboard--V2__Text--Hide text-center mt-lg-4' style={{ maxWidth: '240px' }}>¿Deseas {isGameActive ? 'inhabilitar' : 'habilitar' } el acceso a la dinámica a tus estudiantes? {isGameActive ? 'Inhabilítalo' : 'Habilítalo' } aquí</p>
                            {/* EL SWITCH ESTILO PÍLDORA /}
                            <div
                                className="form-check form-switch mt-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <input 
                                    className="form-check-input"
                                    type="checkbox" 
                                    role="switch" 
                                    id="gameSwitch" 
                                    style={{ cursor: 'pointer', transform: 'scale(1.5)', marginRight: '10px' }}
                                    checked={isGameActive}
                                    onChange={handleSwitchClick}
                                />
                                <label className="form-check-label fw-bold text-center" htmlFor='gameSwitch' style={{ color: isGameActive ? '#198754' : '#dc3545' }}>
                                    {isGameActive ? 'Acceso habilitado' : 'Acceso inhabilitado'}
                                </label>
                            </div>
                        </section>
                    )} */}

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Mis Ztudiantes</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink' onClick={() => navigate('/instructor/groups')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-collection Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Mis grupos</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Crea y gestiona grupos, organiza a tus Ztudiantes según tus necesidades académicas, administra solicitudes y accede a información general.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/groups')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>


                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Blue' onClick={() => navigate('/instructor/ztudents')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-people Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Todos los Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Visualiza y consulta a todos tus Ztudiantes, accede a la información de su perfil y gestiona acciones esenciales.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/ztudents')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>


                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Purple' onClick={() => navigate('/instructor/changeGroup')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-arrow-left-right Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Cambiar Ztudiantes de grupo</p>
                                    
                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Selecciona y mueve Ztudiantes entre tus grupos y organiza su ubicación según tus necesidades académicas.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/changeGroup')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Evaluaciones</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Orange' onClick={() => navigate('/instructor/agenda')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-calendar4-week Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Agenda de evaluaciones</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Programa evaluaciones para tus grupos, consulta, reprograma y mantén el control de acuerdo con tu planeación.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/agenda')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Reportes</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink' onClick={() => DeleteProgressDataInLocalStorageAndGoToNextView()}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-list-check Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Progreso de mis Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta el avance de tus Ztudiantes, visualiza su progreso y da seguimiento a su desempeño.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => DeleteProgressDataInLocalStorageAndGoToNextView()}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>

                            {/* <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink' onClick={() => navigate('/instructor/groups')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-broadcast Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Evaluaciones en este momento</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consultar evaluaciones en proceso</li>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Cancelar evaluaciones en proceso</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/groups')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div> */}

                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Green' onClick={() => navigate('/instructor/results')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-bar-chart-fill Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Resultados de mis Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta los resultados de las evaluaciones, analiza el desempeño aplicando filtros y exporta reportes académicos.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/results')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>

                            <div
                                className={`Dashboard--V2__Sections__List__Items--Instructor ${isLicensesTileEnabled ? 'Dashboard--V2__Sections__List__Items--Purple' : 'Dashboard--V2__Sections__List__Items--Gray'}`}
                                onClick={isLicensesTileEnabled ? () => navigate('/instructor/licenses') : undefined}
                            >
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-files Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Licencias Ztudia</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta la información de las licencias que fueron asignadas y genera los reportes sobre su uso.</li>
                                    </ul>
                                </div>

                                <button
                                    type='button'
                                    className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'
                                    onClick={isLicensesTileEnabled ? () => navigate('/instructor/licenses') : undefined}
                                >
                                    {isLicensesTileEnabled ? (
                                        <i className='bi bi-arrow-right'></i>
                                    ) : (
                                        <i className='bi bi-lock'></i>
                                    )}
                                </button>
                            </div>

                            {(currentCenter.id === 2 || currentCenter.id === 318) && (
                                <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Red' onClick={() => navigate('/instructor/ztudentView')}>
                                    <div>
                                        <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                            <i className='bi bi-person-bounding-box Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                        </figure>

                                        <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Vista del Ztudiante</p>

                                        <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                            <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Visualiza en tiempo real la pantalla y actividad actual de tus Ztudiantes, brinda asistencia inmediata y da seguimiento personalizado.</li>
                                        </ul>
                                    </div>

                                    <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/ztudentView')}>
                                        <i className='bi bi-arrow-right'></i>
                                    </button>
                                </div>
                            )}
                        </div>
                    </section>

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Temarios</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink' onClick={() => navigate('/instructor/syllabus')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-list-task Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Temarios de los cursos</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta los cursos habilitados para tu centro, revisa bloques y temas, accede a los instrumentos de aprendizaje y utilízalos para tu planeación académica.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/syllabus')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    {(currentCenter.id === 2 || currentCenter.id === 318) && (
                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Configuraciones</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Pink' onClick={() => navigate('/instructor/settings')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-gear Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Configuraciones para mis Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Activa o desactiva los instrumentos y actividades del temario; define lo que tus Ztudiantes pueden utilizar.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/settings')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>
                        </div>
                    </section>
                    )}

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Atención al Instructor</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Green' onClick={() => navigate('/instructor/support')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-whatsapp Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Experiencia del Usuario</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Ponte en contacto directo con nuestro equipo de Experiencia del Usuario a través de WhatsApp.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/instructor/support')}>
                                    <i className='bi bi-arrow-right'></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* Funcionando, pero ocultado temporalmente */}
                    {/* <Section textSection={'¿Necesitas ayuda?'} classNameSection={'Section-Separation'}>
                        <div className={`Instructor__Dashboard__Tiles`}>
                            <div className={`Instructor__Dashboard__Tiles__Tile`} onClick={OpenTawkChat}>
                                <p className='Instructor__Dashboard__Tiles__Tile__Icon'><i className="bi bi-chat-dots"></i></p>
                                <p className='Instructor__Dashboard__Tiles__Tile__Text'>Abrir chat</p>
                            </div>
                        </div>
                    </Section> */}

                    {/* INTEGRACIÓN DE TU COMPONENTE CONFIRM */}
                    {showConfirmModal && (
                        <Confirm 
                            message={`¿Deseas ${pendingToggleState ? 'habilitar' : 'inhabilitar'} el acceso a la dinámica de Tiro a gol a tus estudiantes?`}
                            textYesButton={`Sí, ${pendingToggleState ? 'habilitar ahora' : 'inhabilitar ahora'}`}
                            textNoButton="Cancelar"
                            actionToYesButton={confirmToggle}
                            setShowModal={setShowConfirmModal}
                            setConfirmData={setConfirmData}
                        />
                    )}
                </main>
            </BodyWithSideMenu>
        )
    )
}

export { Applicant };